var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('number-management'),_c('internet-post'),_c('phoneshop-post'),_c('group-shop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }